import { merge } from 'lodash';

const defaultArgs = {};

const defaultAttrs = {
  totalAllocPoint: true,
  flakePerSecond: true,
  flake: true,
  booster: true,
  poolCount: true
};

export default (args = {}, attrs = {}) => ({
  farmingInfo: {
    __args: merge({}, defaultArgs, args),
    ...merge({}, defaultAttrs, attrs)
  }
});
